import { render, staticRenderFns } from "./TableViewEditBtn.vue?vue&type=template&id=b1d6a116&scoped=true"
import script from "./TableViewEditBtn.vue?vue&type=script&lang=js"
export * from "./TableViewEditBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1d6a116",
  null
  
)

export default component.exports